export interface LocalAssessmentData {
  assessmentType: 'ia-diagnostic' | 'training-transformation';
  scores: Record<string, { score: number; maxScore: number }>;
  answers: Record<string, any>;
  overallScore: number;
  scoreLevel: any;
  detailedAnswers?: Record<string, any>;
  questionsMetadata?: Record<string, any>;
}

const getStorageKey = (assessmentType: 'ia-diagnostic' | 'training-transformation'): string => {
  return assessmentType === 'ia-diagnostic' ? 'assessment-data-ia' : 'assessment-data-training';
};

// Sauvegarde temporaire, uniquement entre la fin du questionnaire et la
// confirmation de l'enregistrement Supabase.
export const saveAssessmentToLocal = (data: LocalAssessmentData) => {
  try {
    const storageKey = getStorageKey(data.assessmentType);
    localStorage.setItem(storageKey, JSON.stringify(data));

    // Nettoyage des anciennes clés lors de la sauvegarde.
    localStorage.removeItem('assessment-data');
    localStorage.removeItem('audit-results');
    localStorage.removeItem('learning-strategy-results');
    localStorage.removeItem('assessment-data-learning');
  } catch (error) {
    console.error('[LOCAL SAVE] Unable to save assessment data');
    throw error;
  }
};

// Récupération temporaire pour l'enregistrement Supabase.
export const getAssessmentFromLocal = (
  assessmentType?: 'ia-diagnostic' | 'training-transformation',
): LocalAssessmentData | null => {
  try {
    if (!assessmentType) {
      const oldData = localStorage.getItem('assessment-data');
      return oldData ? JSON.parse(oldData) : null;
    }

    const storageKey = getStorageKey(assessmentType);
    const data = localStorage.getItem(storageKey);
    const fallbackData = !data && assessmentType === 'training-transformation'
      ? localStorage.getItem('assessment-data-learning')
      : null;

    return data ? JSON.parse(data) : (fallbackData ? JSON.parse(fallbackData) : null);
  } catch {
    console.error('[LOCAL SAVE] Unable to read assessment data');
    return null;
  }
};

// Nettoyer toutes les données temporaires après une sauvegarde réussie.
export const cleanupLocalStorage = (
  assessmentType: 'ia-diagnostic' | 'training-transformation',
) => {
  localStorage.removeItem(getStorageKey(assessmentType));

  // Défense en profondeur + anciennes clés de migration.
  localStorage.removeItem('assessment-data-ia');
  localStorage.removeItem('assessment-data-training');
  localStorage.removeItem('assessment-data');
  localStorage.removeItem('audit-results');
  localStorage.removeItem('learning-strategy-results');
  localStorage.removeItem('assessment-data-learning');
};
